<div id="qr-code-header" class="header">
  <div class="logo">
    <img  [ngClass]="{'carrier-logo' : partnerName == 'carrier' , 'airoverse-logo' : partnerName == 'airoverse',  'logo-75f': partnerName == '75f' }" src="../../../assets/images/logo.png" alt="Logo" >
  </div>
</div>
<div class="content-layout">
  <!-- Loader Container -->
  <div *ngIf="!profiles" class="loader-container">
    <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '0', height: '200px' }"></ngx-skeleton-loader>
  </div>
 
  <!-- Displaying the terminal graphics after loading -->
  <div *ngIf="profiles">
    <ng-container *ngFor="let profile of profiles;trackBy:profileByID">

      <!-- Displaying the accordion for each profile -->
      <puc-accordion [blockTitle]="formatZoneName(profile,'equipGraphics')" [profileId]="profile?.profile?._id"
        [showActive]="(!profile.isChild || !isModbus)" [isEquipGraphics]="profile['showEquipGraphics']"
        [isQRCode]="true" [isActive]="(profile.profileType == 'pcn' || (profile.profileType == 'connectModule' && isPcnDevice)) ? isPcnModulesOnline(profile) : isModuleOnline(profile)" (displayTimeToggle)="false" (accordianState)="true"
        [isOpen]="true" [siteRef]="refs.siteRef" [showAssetButton]="true" [enableLastUpdatedTime]="false" [enableViewAssets]="profile['enableViewAssets']" [taggedFilesList]="profile['taggedFiles']">


        <!-- Loading Terminal Equip Graphics -->
        <div *ngIf="!showTerminalEquipGraphics && showLoader" class="loader-container">
          <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '0', height: '200px' }"></ngx-skeleton-loader>
        </div>
        
        <ng-container>
        
          <puc-custom-graphics-layout *ngIf="!showPredefinedEquipGraphic?.[profile?.profile?._id]" [profileId]="profile?.profile?._id" [ccuOrZone]="ccuOrZone.type" [buildingObj]="buildings"
            [open]="true" [siteRef]="refs.siteRef" [graphicsFrom]="ccuOrZone.type" [siteName]="" [ccuRef]="refs.ccuId"
            [roomRef]="refs.roomRef" [graphicListChangedEvent]="onGraphicListChangedEvent"
            [isExternal]="true" [childEquipRefs]="childEquipRefs"
            (showPredefinedEquipGraphics)="showPredefinedEquipGraphics($event)">
          </puc-custom-graphics-layout>
        
          <puc-terminal-equip-graphics *ngIf="profile['showEquipGraphics'] && showPredefinedEquipGraphic?.[profile?.profile?._id]" [profile]="profile"
            [multiModuleProfile]="multiModuleProfile" [showLastUpdated]="false" [userTempPreference]="userTempPreference"
            [zoneSettings]="equipGraphicData" [zoneHovercheckFlag]="true" [checkHyperStatProfile]="checkHyperStatProfile"
            [checkHyperStatProfile]="checkHyperStatProfile" [isDomainIntegrated]="isDomainIntegrated">
          </puc-terminal-equip-graphics>
        </ng-container>
        <div class="no-custom-graphics-text" *ngIf="!profile['showEquipGraphics'] && showPredefinedEquipGraphic?.[profile?.profile?._id]">
          No custom graphics to show
        </div>
        
        <puc-asset-data-table [profile]="profile" [isZone]="true">
        </puc-asset-data-table>

        <puc-accordion class="margin-20" blockTitle="Predefined Widgets" [isOpen]="true" (accordianState)="true">

          <!-- Skeleton loader for widgets -->
          <div *ngIf="!profile.widgets">
            <ngx-skeleton-loader count="10" [theme]="{ 'border-radius': '0', height: '50px' }"></ngx-skeleton-loader>
          </div>

          <!-- When there are no widgets available, display a message -->
          <ng-container *ngIf="profile.widgets && !profile.widgets.length">
            <div class="no-widgets" id="noWidgetsText">No widgets available</div>
          </ng-container>

          <!-- Display widgets -->
          <ng-container *ngFor="let widget of profile.widgets">
            <puc-accordion [blockTitle]="formatEquipName(widget.name)" [graphId]="widget.id + profile.profile._id"
              [titleStyle]="accordionHeaderStyle.secondLevel" isOpen="true">
              <puc-widget class="m-l-40">
                <puc-graph [graphWidth]="graphWidth" [graphData]="widget" [graphId]="widget.id + profile.profile._id"
                  [linearData]="" (xAxisCords)="setXAxisCords($event)" [leftPos]="30"
                  [moduleIdentifier]="isPcnDevice && (profile?.profileType == 'pcn' || profile?.profileType == 'connectModule') ? profile?.profile?._id : profile?.portNum"  [moduleRef]="profile.profile._id" [isQRCode]="true">
                </puc-graph>
              </puc-widget>
            </puc-accordion>
          </ng-container>
        </puc-accordion>

      </puc-accordion>
    </ng-container>

  </div>

<!-- Analytics Section -->
  <app-analytics *ngIf="loadAnalytics" [refs]="refs" [ccuOrZone]="'zone'" [buildings]="buildings"></app-analytics>

</div>